import React, {useState} from 'react';

import ModalChooseColorToSwitch from 'components/Colors/ModalChooseColorToSwitch';

function ColorSwitch(props) {
	const {
		currentZoom,
		disabled
	} = props;
	const [openModal, setOpenModal] = useState(false);

	return (
		<>

			<ModalChooseColorToSwitch
				forceOpen={openModal}
				setForceOpenOpen={setOpenModal}
				currentZoom={currentZoom}
			/>

			<button
				type="button"
				className={'btn btntool btn-primary p-0' + (disabled ? ' disabled' : '')}
				onClick={() => {
					setOpenModal(true);
				}}
			>
				<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
				     strokeLinecap="round" strokeLinejoin="round">
					<polyline points="17 1 21 5 17 9"></polyline>
					<path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
					<polyline points="7 23 3 19 7 15"></polyline>
					<path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
				</svg>
			</button>
		</>
	);
}

export default ColorSwitch;
